import { ApiService } from 'services';
import { clearSelectedClient } from 'actions';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

function receive() {
  return {
    type: LOGOUT_SUCCESS
  };
}

export function logoutUser(switchClient, useExtenalLogout) {
  return (dispatch) => {
    // When authenticating via SSO and the user has multiple clients accesible just return them to the Client Select page
    if (switchClient) {
      dispatch(clearSelectedClient());
      return;
    }

    // Log the user out fully
    sessionStorage.clear();
    if (useExtenalLogout) {
      const url = ApiService.getLogoutUrl();
      window.location = url;
    } else {
      dispatch(receive());
    }
  };
}
